import * as yup from "yup";

const TalleresExternosValidacionEsquema = yup.object().shape({
    nombre: yup.string().required()
});

export default TalleresExternosValidacionEsquema;